import { isObjectDeeplyChanged } from '../../../util/state';
import { OverlayContent } from '../../../enums/elementId';
import { State } from '../index';

export const getUpdateFlags = (state: State, oldState: State) => {
    const {
        avcForm,
        isLoading,
        addresses,
        avcResult,
        isOverlayOpen,
        activeOverlay,
        homesPassedType,
        accessSupplier,
        availabilityIndicator,
    } = state;
    const updateForm = (avcForm.index !== oldState.avcForm.index) || !avcForm.touched;
    const homesPassedChanged = homesPassedType !== oldState.homesPassedType;
    const isAvcResultChanged = isObjectDeeplyChanged(avcResult, oldState.avcResult);
    const isOverlayOpened = isOverlayOpen && oldState.isOverlayOpen !== isOverlayOpen;
    const isAvcOpened = isOverlayOpened && activeOverlay === OverlayContent.FORM;
    const accessSupplierChanged = accessSupplier !== oldState?.accessSupplier;
    const availabilityIndicatorChanged = availabilityIndicator !== oldState?.availabilityIndicator;

    return {
        avcForm: updateForm || isAvcOpened,
        addressNotification: addresses.toString() !== oldState.addresses.toString(),
        button: isObjectDeeplyChanged(avcForm, oldState.avcForm),
        isLoading: oldState.isLoading !== isLoading,
        isAvcResultChanged: avcResult && (
            isAvcResultChanged ||
            homesPassedChanged ||
            accessSupplierChanged ||
            availabilityIndicatorChanged
        ),
    };
};
